/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import React from 'react';

const mainContainer = css`
    display: flex;
    align-items: center;
    padding: 6px 10px;
    margin: 2px 0;
    background: white;
    border: 1px solid #e9ecef;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
    font-size: 13px;
    color: #495057;

    &:hover {
        background: #f8f9fa;
        border-color: #adb5bd;
        transform: translateY(-1px);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    &:active {
        transform: translateY(0);
    }
`;

const radioInput = css`
    appearance: none;
    width: 12px;
    height: 12px;
    border: 2px solid #dee2e6;
    border-radius: 50%;
    margin-right: 6px;
    position: relative;
    cursor: pointer;
    transition: all 0.2s ease;
    background: white;

    &:checked {
        border-color: #667eea;
    }

    &:checked::after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 6px;
        height: 6px;
        background: #667eea;
        border-radius: 50%;
    }

    &:hover {
        border-color: #adb5bd;
    }

    &:focus {
        outline: none;
        box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.2);
    }
`;

const label = css`
    cursor: pointer;
    user-select: none;
    font-size: 11px;
    word-break: keep-all;
    flex: 1;
`;

const RadioButton = ({ name, checked, onChange }) => {
    return (
        <div css={mainContainer} onClick={onChange}>
            <input type="radio" checked={checked} onChange={onChange} css={radioInput} />
            <label css={label}>{name}</label>
        </div>
    );
};

export default RadioButton;
